import React from "react";
// import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { BallTriangle } from "react-loader-spinner";

const Loader = ({ height = 80, width = 80, color = "#4fa94d" }) => {
  return (
    <div className="loader position-absolute top-50 start-50 translate-middle">
      <BallTriangle
        height={height}
        width={width}
        color={color}
        ariaLabel="circles-loading"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
      />
    </div>
  );
};

export default Loader;
